import { Injectable } from '@angular/core';
import { PagedAndSortedRequestDto } from '@shared/components/paged-listing-component-base';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServiceBase } from '../service-base';
import { ApiDetailDto, ApiDetailResultDto } from './api-tracking-detail-dto';
import { ApiTrackingDto, ApiTrackingResultDto } from './api-tracking-dto';
import { String } from 'typescript-string-operations';
import { ApiRequest } from "@shared/models/api-request";

@Injectable({
  providedIn: 'root'
})
export class ApiTrackingService extends ServiceBase {
 public list(request: PagedAndSortedRequestDto): Observable<ApiTrackingResultDto> {
    const apiUrl: string = this._appConstants.API.API_TRACKING.LIST;
    const apiRequest: ApiRequest = this._apiService.prepareInputSortAndSearchPage(apiUrl, request);

    return this._apiService.get(apiRequest.apiUrl).pipe(
      map((res: any) => {
        return new ApiTrackingResultDto().deserialize({
          totalCount: res.count,
          items: res.results.map((item: ApiTrackingDto) =>
            new ApiTrackingDto().deserialize(item)
          ),
        });
      })
    );
  }

  public getDetails(request: PagedAndSortedRequestDto, id: number): Observable<ApiDetailResultDto> {
    const apiUrl: string = String.Format(this._appConstants.API.API_TRACKING.GET, id);
    const apiRequest: ApiRequest = this._apiService.prepareInputSortAndSearchPage(
      apiUrl,
      request
    );
    return this._apiService.get(apiRequest.apiUrl).pipe(
      map((res: any) => {
        return new ApiDetailResultDto().deserialize({
          totalCount: res.count,
          items: res.results.map((item: ApiDetailDto) =>
          new ApiDetailDto().deserialize(item)
        ),
        });
      })
    );
  }
}
